// The FlexPDF mark: one page lifted off another (D-39). The same drawing is
// public/favicon.svg, the browser-tab icon.
import { useId } from 'react';

export function Logo(props: { size?: number }) {
  const size = props.size ?? 24;
  // Each copy needs its own gradient id: the homepage and the editor's bar are both in the page.
  const grad = `flexpdf-logo-${useId().replace(/:/g, '')}`;
  return (
    <svg className="logo" width={size} height={size} viewBox="0 0 64 64" aria-hidden="true" focusable="false">
      <defs>
        <linearGradient id={grad} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#4f46e5" />
          <stop offset="0.55" stopColor="#7c3aed" />
          <stop offset="1" stopColor="#db2777" />
        </linearGradient>
      </defs>
      <rect x="9" y="17" width="30" height="40" rx="6" fill="#c4b5fd" transform="rotate(-10 24 37)" />
      <rect x="23" y="8" width="31" height="42" rx="6" fill={`url(#${grad})`} />
      <path d="M30 19h17M30 27h17M30 35h10" stroke="#fff" strokeWidth="3.2" strokeLinecap="round" fill="none" />
    </svg>
  );
}
